import Vue from 'vue'

const vSelect = require('vue-select')

Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css'
